@if (breadcrumbs.length && breadcrumbsEnabled()) {
	<nav
		aria-label="Breadcrumbs"
		id="plp-srlp-breadcrumb"
		class="product-breadcrumbs label-secondary-subtle-static"
	>
		<ul
			class="list-unstyled hmf-my-0 hmf-display-flex hmf-align-items-center hmf-justify-content-center hmf-flex-wrap"
			itemType="http://schema.org/BreadcrumbList"
			itemProp="breadcrumb"
			itemScope
		>
			<li
				class="breadcrumb-links hmf-pb-xxs"
				itemType="http://schema.org/ListItem"
				itemProp="itemListElement"
				itemScope
			>
				<a
					hmf-text-link
					class="hmf-m-0"
					[linkURL]="'/'"
					[dataEm]="'Breadcrumb_Home'"
					itemProp="item"
				>
					<span class="hmf-subheader-m" itemProp="name"> Home </span>
					<meta content="1" itemprop="position" />
				</a>
			</li>
			@for (breadcrumb of breadcrumbs; track trackByFn(index, breadcrumb); let last = $last; let index = $index) {
				<li
					itemType="http://schema.org/ListItem"
					itemProp="itemListElement"
					itemScope
					class="breadcrumb-links hmf-pb-xxs hmf-display-flex hmf-align-items-center"
					[ngClass]="{ 'no-interaction': last }">
					@if (index === 0) {
						<span
							class="hmf-px-xxs"
							>|</span
						>
					}
					<span class="content">
						<a
							hmf-text-link
							class="hmf-m-0"
							[linkURL]="breadcrumb.url"
							itemprop="item"
							[dataEm]="'Breadcrumb_' + dataEm[index]"
						>
						@if (breadcrumb.note) {
							<span
								class="hmf-subheader-m"
								itemprop="name"
							>
								{{ breadcrumb.note }}
							</span>
						} @else {
							<span
								class="hmf-subheader-m"
								itemprop="name"
							>
								{{ breadcrumb.name }}
							</span>
						}
							<meta itemprop="position" content="{{ index + 1 }}" />
						</a>
					</span>
					@if (!last) {
						<span
							class="hmf-px-xxs"
							>|</span
						>
					}
				</li>
			}
		</ul>
	</nav>
}

@if (!breadcrumbs.length || !breadcrumbsEnabled()) {
	<nav
		aria-label="Breadcrumbs"
		class="product-breadcrumbs"
	>
		<ul
			class="list-unstyled hmf-my-0 hmf-mb-m-xxs hmf-display-flex hmf-align-items-center hmf-justify-content-center hmf-flex-wrap"
			itemType="http://schema.org/BreadcrumbList"
			itemProp="breadcrumb"
			itemScope
		>
			<li
				itemType="http://schema.org/ListItem"
				itemProp="itemListElement"
				itemScope
				class="breadcrumb-links hmf-display-flex hmf-justify-content-center hmf-align-items-center hmf-pb-xxs hmf-flex-wrap"
			>
				<a
					hmf-text-link
					class="hmf-m-0"
					itemProp="item"
					[linkURL]="'/'"
					[dataEm]="'Breadcrumb_Home'"
				>
					<span class="hmf-subheader-m" itemProp="name">Home </span>
					<meta content="1" itemprop="position" />
				</a>
				@if (isSearchPage) {
					<span class="hmf-px-xxs">|</span>
					<span class="hmf-subheader-m">Search:</span>
					<span class="breadcrumb-search-term hmf-subheader-bold-m" itemProp="name">
						{{ searchTerm }}
					</span>
					<meta content="2" itemProp="position" />
				}
			</li>
		</ul>
	</nav>
}
